import { Fab } from "@mui/material";
import { useTheme } from "@mui/styles";
import MenuIcon from "@mui/icons-material/Menu";
import React from "react";

const FloatingMenuButton = ({ setIsDrawerOpen }) => {
  const theme = useTheme();
  const handleToggle = () => {
    setIsDrawerOpen(prevState => setIsDrawerOpen(!prevState));
  };
  return (
    <div
      className="col-6 menu-icon"
      style={{ }}
    >
      <Fab
        color={theme.COLORS.GREY.lightGrey3}
        aria-label="add"
        sx={{ boxShadow: "0px 1px 6px #0000000D", width: "54px", height: "54px" }}
        // size="medium"
        onClick={handleToggle}
      >
        <MenuIcon />
      </Fab>
    </div>
  );
};

export default FloatingMenuButton;
